import { Component, input } from '@angular/core';
import { OrganizationModel } from '../../../../core/models/data/organization.model';
import { AuditLogsComponent } from '../../../../parts/audit-logs/audit-logs.component';
import { AuditEntityType } from '../../../../core/enums/base.enums';

@Component({
  selector: 'ms-organization-logs',
  imports: [AuditLogsComponent],
  templateUrl: './organization-profile-logs.component.html'
})
export class OrganizationProfileLogsComponent {
  public organization = input<OrganizationModel | undefined>(undefined);

  public AuditEntityType = AuditEntityType;
}
